import React from "react";
import styled from "styled-components";

import Flexbox from "core/Flexbox";
import colors from "core/colors";
import BodyText from "core/BodyText";
import Heading from "core/Heading";
import breakpoints from "core/breakpoints";

import { convertPxToRem } from "frontend/components/helpers";
import {
    handleBottomSpacing,
    handleTopSpacing
} from "js/helpers/spacingAndFonts";

export const SubscriptionTypeContainer = styled(Flexbox).attrs({
    flexDirection: "column"
})`
    border-top: ${convertPxToRem({ px: 1 })} solid ${colors.concrete};
    border-bottom: ${convertPxToRem({ px: 1 })} solid ${colors.concrete};

    ${handleBottomSpacing({ bottomSpacing: "lg" })};
    ${handleTopSpacing({ topSpacing: "lg" })};
`;

export const FormContainer = styled.div`
    ${handleTopSpacing({ topSpacing: "2xl" })};
`;

export const IconSubInfo = styled(Flexbox).attrs({
    flexDirection: "row",
    justifyContent: "space-between"
})`
    ${handleBottomSpacing({ bottomSpacing: "sm" })}
`;

export const SubscriptionSubText = styled(BodyText).attrs({
    size: "md",
    copyColor: colors.storm
})`
    ${handleTopSpacing({ topSpacing: "sm" })};
`;

export const Disclaimer = styled(BodyText)`
    ${handleTopSpacing({ topSpacing: "lg" })}
`;

export const SubscriptionCheckoutHeader = styled(Flexbox).attrs({
    flexDirection: "row",
    alignItems: "center"
})`
    ${handleBottomSpacing({ bottomSpacing: "lg" })}
`;

export const USDText = styled(BodyText).attrs({
    size: "sm",
    copyColor: colors.storm
})`
    padding-left: ${convertPxToRem({ px: 8 })};
`;

export const SubDescContainer = styled(BodyText)`
    ${handleBottomSpacing({ bottomSpacing: "lg" })}
`;

export const TeamInfoContainer = styled(Flexbox).attrs({
    flexDirection: "column"
})``;

export const LicenseRadioContainer = styled.div`
    ${handleBottomSpacing({ bottomSpacing: "2xl" })}
`;

export const CheckoutPageHeading = styled(Heading)`
    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        padding-left: ${convertPxToRem({ px: 15 })};
        padding-right: ${convertPxToRem({ px: 15 })};
    }
`;
export const EduOrderTitle = styled(Heading).attrs({
    size: "xs",
    type: "h2",
    bottomSpacing: "lg"
})``;
